import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'

function Heading() {
  const { t } = useTranslation('fansiWin')

  return (
    <div className="flex flex-col justify-center px-4 md:px-12 lg:items-center lg:flex-row lg:px-40 lg:gap-12 lg:pt-12">
      <div className="mb-6 sm:hidden">
        <Image
          alt="mail"
          src="/assets/fansi-win/logo.png"
          height={100}
          width={240}
          layout="fixed"
          quality={75}
          loading="eager"
        />
      </div>
      <div className="hidden mb-6 sm:block lg:hidden">
        <Image
          alt="mail"
          src="/assets/fansi-win/logo.png"
          height={140}
          width={320}
          layout="fixed"
          quality={75}
          loading="eager"
        />
      </div>
      <div className="hidden lg:block">
        <Image
          alt="mail"
          src="/assets/fansi-win/logo.png"
          height={180}
          width={400}
          layout="fixed"
          quality={75}
          loading="eager"
        />
      </div>
      <div className="2xl:pr-80">
        <h1 className="text-[#839ABD] font-medium text-xl">{t('heading')}</h1>
        <h1 className="text-[#839ABD] font-medium text-xl">{t('heading_1')}</h1>
        <p className="text-[#7A7A7A]">
          {t('heading_2')}
          <span className="text-[#839ABD] font-bold">
            {t('heading_hash_1')}
          </span>
          <span className="text-[#839ABD] font-bold">
            {t('heading_hash_1')}
          </span>
        </p>
      </div>
    </div>
  )
}

export default Heading
